<template>
  <div>
    <v-autocomplete
      :value="tariffCategory"
      :items="filterTariffCategories"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :multiple="isMultiple"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="isMultiple">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >{{ data.item.name }}</div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="tariffCategoryCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Category") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-tariff-category-create @select="addTariffCategory" :showDialog="tariffCategoryCreateDialog"></z-tariff-category-create>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TariffCategorySelect",
  props: {
    value: {
      default: false
    },
    label: {
      default: "Tariff Category"
    },
    multiple: {
      default: false
    },
    clearable: {
      default: false
    }
  },
  mixins: [Themeable, commonMixin]
})
export default class TariffCategorySelect extends (Vue, Themeable) {
  tariffCategory = null;
  loading = true;
  filter = "";
  tariffCategoryCreateDialog = false;
  isMultiple = false;

  clear() {
    this.filter = "";
    this.tariffCategory = null;
    this.$emit("input", null);
  }

  get filterTariffCategories() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const tariffCategories = corpService.tariffCategories;

    if (filterby == "") {
      return tariffCategories;
    } else {
      const fc = tariffCategories.filter(function(c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (!this.isMultiple) {
      if (newVal && newVal._id) {
        this.$emit("input", newVal._id);
        return;
      }
      if (!newVal) this.$emit("input", null);
    } else {
      const response = [];

      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i]);
      }

      this.$emit("input", response);
      return;
    }
  }

  async init() {
    this.isMultiple = this.multiple === "" || this.multiple === true;
    await corpService.populateTariffCategories();
    const tCategories = corpService.tariffCategories;
    if (this.value && !this.isMultiple) {
      for (let i = 0; i < tCategories.length; i++) {
        if (tCategories[i]._id === this.value) {
          this.tariffCategory = tCategories[i];
          break;
        }
      }
    } else {
      this.tariffCategory = [];
      if (this.value != null && Array.isArray(this.value)) {
        for (let i = 0; i < tCategories.length; i++) {
          if (this.value.filter(e => e === tCategories[i].name).length > 0) {
            this.tariffCategory.push(tCategories[i]);
          }
        }
      }
    }
  }

  async addTariffCategory() {
    this.tariffCategoryCreateDialog = false;
    await this.init();
    this.changedTo();
    console.log();
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val._id != null && this.tariffCategory != null) {
      if (Array.isArray(this.tariffCategory)) {
        for (let i = 0; i < this.tariffCategory.length; i++) {
          if (val._id === this.tariffCategory[i]._id) {
            return true;
          }
        }
      } else if (
        this.tariffCategory != null &&
        this.tariffCategory._id != undefined
      ) {
        if (val._id === this.tariffCategory._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.tariffCategory = null;
    }
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
